module.exports = __webpack_public_path__ + "media/img/Landing_Page/logos/31-e8654962341afbac8f94bc444f574575.jpg";